export default __webpack_public_path__ + "static/media/audit-widget-logo.13a869a8.svg";